import { Action, State, StateContext } from '@ngxs/store';
import * as actions from './puzzle-framework-config.actions';
import { PuzzleFrameworkConfigModel } from 'projects/tools/src/lib/store/puzzle-framework-config.model';
import { Injectable } from '@angular/core';
// @dynamic
@State<PuzzleFrameworkConfigModel>({
  name: 'puzzleFrameworkConfig',
  defaults: {
    title: 'Krupion Kreuzworträtsel STATEMARKER',
    privacyPolicy: 'assets/privacy.html',
    googleAnalyticsCode: null,
    googleAnalyticsUpdateInterval: 0.5,
    adTagUrl: null,
    puzzleFiles: {
      monday: {
        puzzleFile: 'assets/swedish/2019_04_20.xml',
        advertisements: [
          {
            imageUrl: 'assets/logo.png',
            link: 'https://www.krupion.de',
            top: 10,
            left: 5,
            width: 18,
            height: 18,
          },
          {
            imageUrl: 'assets/logo.png',
            top: 33,
            left: 22,
            width: 6,
            height: 8,
          },
        ],
      },
      tuesday: {
        puzzleFile: 'assets/swedish/01.xml',
        advertisements: [
          {
            imageUrl: 'assets/logo.png',
            link: 'https://www.krupion.de',
            top: 4,
            left: 5,
            width: 5,
            height: 3,
          },
        ],
      },
      wednesday: 'assets/swedish/RK00_00_1419.xml',
      thursday: {
        puzzleFile: 'assets/swedish/RK00_00_1515.xml',
      },
      daily: 'assets/swedish/daily-${yyyy-MM-dd}.xml',
    },
    defaultPuzzle: 'wednesday',
    defaultLanguage: 'de',
    defaultGermanSalutation: 'du',
    jokerButton: {
      unit: 'absolute',
      value: 2,
    },
    zoomOutLimit: 0.1,
    zoomInLimit: 3,
    minZoomOutSolutionWord: 0.7,
    minZoomOutSolutionWordMobile: 0.6,
    minAutoZoomOut: 0.9,
    minAutoZoomOutMobile: 0.65,
    maxAutoZoomIn: 2,
    maxAutoZoomInMobile: 2,
    androidPasswordInputFix: false,
    solutionUrl: '',
    mobileMinLandscapeHeight: 400,
    allowMobileVerticalTopBar: true,
    layout: {
      default: {
        width: 16,
        tiles: [
          {
            type: 'buttonbar',
            rows: 1,
            cols: 6,
          },
          {
            type: 'empty',
            rows: 1,
            cols: 8,
          },
          {
            type: 'timer',
            rows: 1,
            cols: 2,
          },
          // {
          //   type: 'moves',
          //   rows: 1,
          //   cols: 1
          // },
          {
            type: 'board',
            rows: 8,
            cols: 16,
          },
          {
            type: 'solutionWord',
            rows: 1,
            cols: 16,
          },
        ],
      },
      small: {
        width: 16,
        tiles: [
          {
            type: 'buttonbar',
            rows: 1,
            cols: 11,
          },
          {
            type: 'empty',
            rows: 1,
            cols: 1,
          },
          {
            type: 'timer',
            rows: 1,
            cols: 4,
          },
          // {
          //   type: 'moves',
          //   rows: 1,
          //   cols: 3
          // },
          {
            type: 'board',
            rows: 8,
            cols: 16,
          },
          {
            type: 'solutionWord',
            rows: 1,
            cols: 16,
          },
        ],
      },
      large: {
        width: 16,
        tiles: [
          {
            type: 'buttonbar',
            rows: 1,
            cols: 5,
          },
          {
            type: 'empty',
            rows: 1,
            cols: 9,
          },
          {
            type: 'timer',
            rows: 1,
            cols: 1,
          },
          // {
          //   type: 'moves',
          //   rows: 1,
          //   cols: 1
          // },
          {
            type: 'board',
            rows: 8,
            cols: 16,
          },
          {
            type: 'solutionWord',
            rows: 1,
            cols: 16,
          },
        ],
      },
    },
    buttonBarOrder: ['joker', 'check', 'zoom-in', 'zoom-out', 'reset', 'help', 'privacy', 'fullscreen'],
    showTimer: false,
    customButtons: [
      {
        showName: false,
        name: 'Info',
        showIcon: true,
        icon: 'insert_emoticon',
        showImage: false,
        showTooltip: true,
        url: 'https://www.google.com',
      },
      {
        showName: false,
        showIcon: false,
        showImage: true,
        image: './assets/Demo/facebook.png',
        showTooltip: true,
        url: 'https://www.facebook.com',
      },
    ],
    hideWelcomeDialog: false,
    hideWelcomeBackDialog: false,
    wordSearchBottomWordListOnly: false,
    winScreenPrintButton: false,
    solutionWordConfig: {
      sweepstake: {
        enabled: false,
      },
      solutionDialogEnabled: false,
    },
    urlLanguageParameterEnabled: false,
    swedishPuzzleLegacy: false,
    autoZoomEnabledDefaultMobile: true,
    autoZoomEnabledDefaultDesktop: true,
    definitionBarEnabledDefaultMobile: true,
    definitionBarEnabledDefaultDesktop: true,
    wordJumpOnDefaultMobile: true,
    wordJumpOnDefaultDesktop: false,
    crosswordBoardConfig: {
      definFields: 'default',
      crosswordSidebar: 'default',
      fieldNumbers: 'default',
      splitWordList: 'default',
      splitDefinList: 'default',
    },
    removeSideMargins: false,
    nativeKeyboard: false,
    nativeKeyboardAllowUserChange: true,
    keepKeyboardOpen: false,
    keepKeyboardOpenAllowUserChange: true,
    showSolutionTime: 2000,
    weekStartOffsetFromMonday: 0,
    leaderboardEnabled: false,
    leaderboardTimezone: 'Vienna/Austria',
    leaderboardSubmissionSeconds: 86400,
    leaderboardSubmissionPolicy: 'first-only',
    feedbackFeatures: [],
    rumpelstilzchenReload: ['849e702446be2755d7c7d587adf840f7'],
    rumpelstilzchenNoReload: ['9e376eff2d459d49d5c9185fff6987a5'],
    forceDarkMode: undefined, // nothing forced by default
  },
})
@Injectable()
export class PuzzleFrameworkConfigState {
  @Action(actions.UpdateFrameworkConfig)
  UpdateFrameworkConfig(state: StateContext<PuzzleFrameworkConfigModel>, action: actions.UpdateFrameworkConfig) {
    const currentPuzzleFrameworkConfig = JSON.parse(JSON.stringify(state.getState()));
    Object.assign(currentPuzzleFrameworkConfig, action.payload.puzzleFrameworkConfig);
    state.setState(currentPuzzleFrameworkConfig);
  }
}
